module.exports = __webpack_public_path__ + "img/ojo.2f9c6a0e.svg";